import dayjs from "dayjs";
import * as yup from "yup";
import { YES, TRUE, NO_DEGREE } from "../constants/uiControls";

const step0 = {};

const step1 = yup.object().shape({
  identificationType: yup.object().shape({
    value: yup.string().required("El tipo de documento es requerido"),
  }),
  identificationNumber: yup.object().shape({
    value: yup
      .number()
      .typeError("El valor debe ser númerico")
      .positive("Número de identificación inválido")
      .integer("Número de identificación inválido")
      .min(5, "Número de identificación inválido")
      .required("El número de documento es requerido"),
  }),
  name: yup.object().shape({
    value: yup.string().required("El nombre es requerido"),
  }),
  lastName: yup.object().shape({
    value: yup.string().required("El apellido es requerido"),
  }),
});

const step2 = yup.object().shape(
  {
    gender: yup.object().shape({
      value: yup.string().required("El género es requerido"),
    }),
    birthCountry: yup.object().shape({
      value: yup.string().required("El país de nacimiento es requerido"),
    }),
    birthState: yup.object().shape({
      value: yup.string().required("El departamento de nacimiento es requerido"),
    }),
    birthCity: yup.object().shape({
      value: yup.string().required("El municipio de nacimiento es requerido"),
    }),
    birthDate: yup.object().shape({
      value: yup
        .date()
        .nullable()
        .typeError("Fecha de nacimiento Inválida")
        .required("La fecha de nacimiento es requerida")
        .test("Date of Birth", "Debes ser mayor o igual a 16 años", function (value) {
          return dayjs().diff(dayjs(value), "years") >= 16;
        }),
    }),
    maritalStatus: yup.object().shape({
      value: yup.string().required("El estado civil es requerido"),
    }),
    socialGroups: yup.object().shape({
      value: yup.string().required("El grupo poblacional es requerido"),
    }),
    sisben: yup.object().shape({
      value: yup.string().required("Indique si tiene SISBEN"),
    }),
    sisbenCategory: yup.object().when("sisben", {
      is: (data: any) => data?.value === TRUE && true,
      then: yup.object().shape({
        value: yup.string().required("La categoría es requerida"),
      }),
    }),
  },
  [["sisben", "sisbenCategory"]]
);

const step3 = yup.object().shape({});

const step4 = yup.object().shape(
  {
    hasCellPhone: yup.object().shape({
      value: yup.string().required("Especifique si tiene celular"),
    }),
    cellPhoneNumber: yup.object().when("hasCellPhone", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup
          .string()
          .matches(/^[0-9]{10}$/, "Número de celular inválido")
          .required("El número de celular es requerido"),
      }),
    }),
    cellPhoneCompany: yup.object().when("hasCellPhone", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("El operador es requerido"),
      }),
    }),
    email: yup.object().shape({
      value: yup.string().required("El correo electrónico es requerido").email("El email es incorrecto"),
    }),
    emergencyContactName: yup.object().shape({
      value: yup.string().required("El nombre del contacto de emergencia es requerido"),
    }),
    relationshipEmergencyContact: yup.object().shape({
      value: yup.string().required("Especifique la relación con el contacto de emergencia"),
    }),
    emergencyContactPhoneNumber: yup.object().shape({
      value: yup
        .string()
        .matches(/^[0-9]{10}$/, "Número de celular inválido")
        .required("El  nÚmero de celular es requerido"),
    }),
  },
  [["cellPhoneNumber", "cellPhoneCompany"]]
);

const step5 = yup.object().shape({
  transportation: yup.object().shape({
    value: yup.string().required("El medio de transporte es requerido"),
  }),
  transportationTime: yup.object().shape({
    value: yup.string().required("Especifique cuanto tarda en movilizarse de la casa a la empresa"),
  }),
  emergencyCorps: yup.object().shape({
    value: yup.string().required("Especifique si es brigadista"),
  }),
  hasEmploymentFund: yup.object().shape({
    value: yup.string().required("Especifique si pertenece a un fondo de empleados"),
  }),
});

const step6 = yup.object().shape({
  placeCountry: yup.object().shape({
    value: yup.string().required("El país de residencia es requerido"),
  }),
  placeState: yup.object().shape({
    value: yup.string().required("El departamento de residencia es requerido"),
  }),
  placeCity: yup.object().shape({
    value: yup.string().required("El municipio de residencia es requerido"),
  }),
  neighborhood: yup.object().shape({
    value: yup.string().required("La Vereda o el barrio es requerido"),
  }),
  address: yup.object().shape({
    value: yup.string().required("La dirección es requerida"),
  }),
  dwellTime: yup.object().shape({
    value: yup.string().required("El tiempo de residencia es requerido"),
  }),
  houseLocation: yup.object().shape({
    value: yup.string().required("El tipo de ubicación es requerido"),
  }),
  category: yup.object().shape({
    value: yup.string().required("El estrato es requerido"),
  }),
  houseType: yup.object().shape({
    value: yup.string().required("El tipo de vivienda es requerido"),
  }),
  houseTenure: yup.object().shape({
    value: yup.string().required("El tipo de tenencia es requerido"),
  }),
});

const step7 = yup.object().shape(
  {
    houseContition: yup.object().shape({
      value: yup.string().required("Especifique la condición de la vivienda"),
    }),
    houseStatus: yup.object().when("houseContition", {
      is: (data: any) => data?.value === "3BAE3882-1D00-44E9-894F-3FB64DEE73EC" && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique el estado de la construción"),
      }),
    }),

    rooms: yup.object().shape({
      value: yup
        .number()
        .typeError("El valor debe ser númerico")
        .positive("Número inválido")
        .integer("Número inválido")
        .min(0, "Número inválido")
        .max(10, "Número maximo inválido")
        .required("Especifique el número de habitaciones"),
    }),
    houseServices: yup
      .array()
      .min(1, "Indique al menos un servicio de la vivienda")
      .required("Indique al menos un servicio de la vivienda"),
  },
  [["houseContition", "houseStatus"]]
);

const step8 = yup.object().shape({
  properties: yup.array().min(1, "Indique los bienes en su hogar").required("Indique una respuesta"),
  techProperties: yup.array().min(1, "Indique los bienes de tecnología en su hogar").required("Indique una respuesta"),
  computers: yup.object().shape({
    value: yup
      .number()
      .typeError("El valor debe ser númerico")
      .positive("Número inválido")
      .integer("Número inválido")
      .min(0, "Número inválido")
      .max(20, "Número maximo inválido")
      .required("Especifique el número de habitaciones"),
  }),
  socialNetworks: yup.array().min(1, "Indique que redes sociales utiliza").required("Indique una respuesta"),
});

const step9 = yup.object().shape(
  {
    home: yup.object().shape({
      value: yup.string().required("Especifique si tiene vivienda propia"),
    }),
    homeOwnership: yup.array().when("home", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Especifique a nombre de quien esta la escritura de la vivienda").required(),
    }),
    land: yup.object().shape({
      value: yup.string().required("Especifique si tiene lote propio"),
    }),
    landOwnership: yup.array().when("land", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Especifique a nombre de quien esta la escritura de la vivienda").required(),
    }),
  },
  [["homeOwnership", "landOwnership"]]
);

const step10 = yup.object().shape({
  familyGroup: yup.array().min(1, "Especifique su grupo familiar").required(),
  familyGroupPosition: yup.object().shape({
    value: yup.string().required("Especifique su posición en el grupo familiar"),
  }),
});

const step11 = yup.object().shape(
  {
    hasMate: yup.object().shape({
      value: yup.string().required("Especifique si tiene pareja"),
    }),

    mateDateOfBirth: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup
          .date()
          .nullable()
          .typeError("Fecha de nacimiento Inválida")
          .test("Date of Birth", "Debe ser mayor de 18 años", function (value) {
            return dayjs().diff(dayjs(value), "years") >= 18;
          })
          .required("La fecha de nacimiento es requerida"),
      }),
    }),

    mateGender: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique el género de la pareja"),
      }),
    }),

    areTogether: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si vive con su pareja"),
      }),
    }),

    mateOccupation: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("La ocupación de la pareja es requerida"),
      }),
    }),

    isSameOccupation: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si su pareja trabaja en el sector de las flores"),
      }),
    }),
    mateProfession: yup.object().when("hasMate", {
      is: (data: any) => {
        return data?.value === YES && true;
      },

      then: yup.object().shape({
        value: yup.string().nullable().required("El sector de trabajo de la pareja es requerido"),
      }),
    }),

    educationLevel: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("E nivel educativo de la pareja es requerido"),
      }),
    }),

    isCurrentlyStudying: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si su pareja esta estudiando"),
      }),
    }),
    isContributor: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si su pareja es contribuyente"),
      }),
    }),

    isDependant: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si su pareja depende económicamente de usted"),
      }),
    }),

    hasDisability: yup.object().when("hasMate", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique si su pareja tiene alguna discapacidad"),
      }),
    }),

    disability: yup.object().when("hasDisability", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup.string().required("Especifique el tipo de discapacidad de su pareja"),
      }),
    }),
  },
  [["hasMate", "hasDisability"]]
);

const step12 = yup.object().shape(
  {
    hasChildren: yup.object().shape({
      value: yup.string().required("Especifique si tiene hijos"),
    }),
    numberOfChildren: yup.object().when("hasChildren", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup
          .number()
          .typeError("Número de hijos inválido")
          .positive("Agregue minimo un registro")
          .integer("Número de hijos inválido")
          .max(25, "Número maximo inválido")
          .required("Agregue minimo un registro"),
      }),
    }),
    template: yup.array().when("hasChildren", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().of(
        yup.object().shape({
          "b6494e87-8f68-4a03-a9c8-82e42e612e92": yup.string().required("Especifique el nombre del hijo"),
          "ca20eddb-71f7-4287-9bb1-f11e7ab92c12": yup
            .date()
            .nullable()
            .typeError("Fecha de nacimiento Inválida")
            .required("La fecha de nacimiento es requerida"),
          "488b58f7-59ce-4237-8691-40c99cc12206": yup.string().required("Indique el género de su hijo"),
          "034271f1-e2e2-4aa3-a698-383977f5cc54": yup.string().required("Indique si el hijo vive con usted"),
          "2d5468a1-d937-4139-bda5-a80da9e31226": yup.string().required("Indique quien cuida al hijo"),
          "6f65647b-8923-404c-b1d1-d7b6eaac71c5": yup.string().required("Indique si el hijo tiene alguna discapacidad"),
          "b7351d2a-de2a-4d73-b411-cae46915dec1": yup.string().when("6f65647b-8923-404c-b1d1-d7b6eaac71c5", {
            is: (data: any) => {
              return data === YES && true;
            },
            then: yup.string().required("Espefique el tipo de discapacidad del hijo"),
          }),
          "54935073-f7fd-498d-85cc-0cd80349c9fd": yup.string().required("Indique si su hijo aporta económicamente"),
          "f8f2f738-70d4-4241-9c66-33de707dac41": yup
            .string()
            .required("Indique si su hijo depende económicamente de usted"),
          "14fa7d4f-6436-4c85-a70a-cc0c36522d80": yup.string().required("Indique si su hijo recibe subsidio familiar"),
          "38f0d3c5-935e-4cc0-8fcd-191cbf80d98e": yup
            .string()
            .required("Indique el ultimo nivel de estudios de su hijo"),
          "ba3587c6-b3b4-4148-8c7a-8385ca511f93": yup
            .string()
            .required("Indique si su hijo esta estudiando actualmente"),
          "0bf0fb9f-6e59-4bae-b644-420accbb5671": yup
            .string()
            .required("Indique si su hijo participa en actividades extracurriculares"),
          "3c858265-5760-430f-bfe1-1f2f48ccd415": yup.string().when("0bf0fb9f-6e59-4bae-b644-420accbb5671", {
            is: (data: any) => {
              return data === YES && true;
            },
            then: yup.string().required("Espefique el tipo de actividad extracurricular de su hijo"),
          }),
          "f10858af-61e7-4e8f-86a9-4b046a3c2d2a": yup.array().when("ba3587c6-b3b4-4148-8c7a-8385ca511f93", {
            is: (data: any) => {
              return data === YES && true;
            },
            then: yup.array().min(1, "Seleccione al menos 1 respuesta").required(),
          }),
          "cd796fc6-8164-4359-bc1e-02e666640907": yup.array().min(1, "Seleccione al menos 1 respuesta").required(),
        })
      ),
      //.min(1, "Agregue mínimo un registro")
      // .required("Agregue mínimo un registro"),
    }),
  },
  [["hasChildren", "numberOfChildren"]]
);

const step13 = yup.object().shape({
  template: yup.array().of(
    yup.object().shape({
      "8ec35cdc-1ae8-4bc2-a9c7-37e73da8a953": yup.string().required("El nombre del familiar es requerido"),
      "f79e4215-d3df-4f40-b349-8fbb54c2bf47": yup.string().required("El género del familiar es requerido"),
      "acde57e7-a501-4ab8-80ad-37d3997966c6": yup.string().required("Indique el parentesco del familiar"),
      "b21713a3-6887-4e33-bd39-006ecefa82c2": yup.string().required("El rango de edad del familiar es requerido"),
      "5969d844-5ad1-40f7-8aa0-aae1f1b50bd0": yup.string().required("Indique si el familiar aporta económicamente"),
      "c93e8a1e-6a34-4acb-a695-f21d022641ff": yup
        .string()
        .required("Indique si el familiar depende económicamente de usted"),
      "d794fc8e-21b6-4047-b830-0438e3d0f79c": yup.string().required("Indique si el familiar recibe subsidio"),
      "66f1f969-4229-4e07-8fb2-1329a944a27a": yup
        .string()
        .required("Indique si el familiar presenta alguna discapacidad"),
      "60cf024c-a999-4366-884f-f2fd296053d2": yup.string().when("66f1f969-4229-4e07-8fb2-1329a944a27a", {
        is: (data: any) => {
          return data === YES && true;
        },
        then: yup.string().required("Espefique el tipo de discapacidad"),
      }),
    })
  ),
});

const step14 = yup.object().shape(
  {
    educationLevel: yup.object().shape({
      value: yup.string().required("El nivel educativo es requerido"),
    }),
    degreeName: yup.object().when("educationLevel", {
      is: (data: any) => {
        return data?.value !== NO_DEGREE && true;
      },
      then: yup.object().shape({
        value: yup.string().required("El nombre del título es requerido"),
      }),
    }),
    isStudying: yup.object().shape({
      value: yup.string().required("Especifique si esta estudiando"),
    }),
    careerName: yup.object().when("isStudying", {
      is: (data: any) => {
        return data?.value === YES && true;
      },
      then: yup.object().shape({
        value: yup.string().required("El nombre de la carrera es requerido"),
      }),
    }),
    careerModality: yup.object().when("isStudying", {
      is: (data: any) => {
        return data?.value === YES && true;
      },
      then: yup.object().shape({
        value: yup.string().required("La modalidad de la carrera es requerida"),
      }),
    }),
    studyDays: yup.object().when("isStudying", {
      is: (data: any) => {
        return data?.value === YES && true;
      },
      then: yup.object().shape({
        value: yup.string().required("Especifique los días de estudio"),
      }),
    }),
    studySchedule: yup.object().when("isStudying", {
      is: (data: any) => {
        return data?.value === YES && true;
      },
      then: yup.object().shape({
        value: yup.string().required("El horario de estudio es requerido"),
      }),
    }),
  },
  [["educationLevel", "degreeName"]]
);

const step15 = yup.object().shape(
  {
    isOtherLanguage: yup.object().shape({
      value: yup.string().required("Especifique si habla otro idioma"),
    }),
    computingKnowledge: yup
      .array()
      .min(1, "Seleccione al menos 1 conocimiento en informática")
      .max(3, "Seleccione máximo tres opciones")
      .required(),
    languageList: yup.array().when("isOtherLanguage", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Agregue al menos 1 idioma").required(),
    }),
    knowledgeRanking: yup
      .array()
      .min(1, "Seleccione al menos 1 necesidad que considere importante")
      .max(3, "Seleccione máximo tres opciones")
      .required(),
  },
  [["otherLanguages", "otherLanguages"]]
);

const step16 = yup.object().shape(
  {
    additionalIncomes: yup.object().shape({
      value: yup.string().required("Especifique si tiene ingresos adicionales"),
    }),
    incomesType: yup.array().when("additionalIncomes", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Especifique los tipos de ingreso").required(),
    }),
    incomesAverage: yup.object().when("additionalIncomes", {
      is: (data: any) => data?.value === YES && true,
      then: yup.object().shape({
        value: yup
          .number()
          .typeError("El valor debe ser númerico")
          .positive("Número de identificación inválido")
          .integer("Número de identificación inválido")
          .required("Indique el valor mensual de sus ingresos"),
      }),
    }),
    incomesDestination: yup.array().min(1, "Seleccione al menos 1 tipo").max(3, "Seleccione máximo 3 tipos").required(),
    bankingProducts: yup.array().min(1, "Indique al menos 1 respuesta").required(),
    isSaveMoney: yup.object().shape({
      value: yup.string().required("Indique si posee habitos de ahorro"),
    }),
    saveAverage: yup.object().when("isSaveMoney", {
      is: (data: any) => data?.value === TRUE && true,
      then: yup.object().shape({
        value: yup
          .number()
          .typeError("El valor debe ser númerico")
          .positive("Número de identificación inválido")
          .integer("Número de identificación inválido")
          .required("Indique el promedio mensual de sus ahorros"),
      }),
    }),
  },
  [["additionalIncomes", "incomesType"]]
);

const step17 = yup.object().shape(
  {
    policies: yup.array().min(1, "Indique con cuales polizas cuenta").required(),
    hasPCS: yup.object().shape({
      value: yup.string().required("Indique si posee plan complementario de salud"),
    }),
    pcsNames: yup.array().when("hasPCS", {
      is: (data: any) => data?.value === TRUE && true,
      then: yup.array().min(1, "Indique sus planes complementarios de salud").required(),
    }),
  },
  [["hasPCS", "pcsNames"]]
);

const step18 = yup.object().shape({
  buyingPlace: yup.array().min(1, "Indique dónde realiza la compra").required(),
  buyingFrequency: yup.object().shape({
    value: yup.string().required("Indique la frecuencia con la que realiza la compra"),
  }),
  foodConsumed: yup.array().min(1, "Seleccione al menos 1 alimento").max(2, "Seleccione máximo 2 alimentos").required(),
  isFoodGrown: yup.object().shape({
    value: yup.string().required("Indique si produce alimentos para autoconsumo"),
  }),
  watterAvailability: yup.object().shape({
    value: yup.string().required("Espeficique la frecuencia con la que dispone de agua"),
  }),
  completedFood: yup.object().shape({
    value: yup.string().required("Indique cuantas comidas completas consume al día"),
  }),
});

const step19 = yup.object().shape(
  {
    hasPersonalProject: yup.object().shape({
      value: yup.string().required("Indique si tiene algún proyecto o meta personal"),
    }),
    projectType: yup.array().when("hasPersonalProject", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Indique de que tipo es su proyecto o meta personal").required(),
    }),
    projectRequeriments: yup.array().when("hasPersonalProject", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Indique que falta para cumplir su proyecto o meta personal").required(),
    }),
    needsOrConcerns: yup
      .array()
      .min(1, "Indique aspectos de su vida con mayores necesidades o preocupaciones")
      .required(),
  },
  [["hasPersonalProject", "projectType"]]
);

const step20 = yup.object().shape(
  {
    hoobies: yup.array().min(1, "Indique que actividades realiza").required(),
    desiredHobbies: yup.array().min(1, "Indique que actividades le gustaría realizar en su tiempo libre").required(),
    needs: yup.array().min(1, "Indique que le hace falta para realizarlas").required(),
    hasCommunityActivities: yup.object().shape({
      value: yup.string().required("Indique si participa en actividades comunitarias"),
    }),
    communityActivities: yup.array().when("hasCommunityActivities", {
      is: (data: any) => data?.value === YES && true,
      then: yup.array().min(1, "Especifique en que actividades comunitarias participa").required(),
    }),
  },
  [["hasCommunityActivities", "communityActivities"]]
);

export const schemaArray = [
  step0,
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9,
  step10,
  step11,
  step12,
  step13,
  step14,
  step15,
  step16,
  step17,
  step18,
  step19,
  step20,
];
